import { render, staticRenderFns } from "./ActivationLinkExpired.vue?vue&type=template&id=c197e91e&scoped=true"
import script from "./ActivationLinkExpired.vue?vue&type=script&lang=js"
export * from "./ActivationLinkExpired.vue?vue&type=script&lang=js"
import style0 from "./ActivationLinkExpired.vue?vue&type=style&index=0&id=c197e91e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c197e91e",
  null
  
)

export default component.exports